(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('TranslationDetailController', TranslationDetailController);

    TranslationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Translation'];

    function TranslationDetailController($scope, $rootScope, $stateParams, previousState, entity, Translation) {
        var vm = this;

        vm.translation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:translationUpdate', function(event, result) {
            vm.translation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
